// extracted by mini-css-extract-plugin
export default {"ring":"progressRing_ring__Zx-Ri","track":"progressRing_track__ZvAtf","fill":"progressRing_fill__t4k3z","label":"progressRing_label__nUhct"};